import React from "react";
import { useNavigate } from "react-router-dom";
import {
  SearchIcon,
  FilterIcon,
  DumbleIcon,
  XIcon,
} from "../../../images/icons/icons";

const AllGymOffersBanner = ({ searchValue = "", onSearchChange = () => {} }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="all-gym-offer-banner">
      <button
        className="all-gym-offer-back-button"
        onClick={handleBackClick}
        title="Go back"
      >
        <XIcon color="#fff" />
      </button>

      <div className="all-gym-offer-banner-header">
        <div className="all-gym-offer-banner-icon">
          <DumbleIcon color="#fff" />
        </div>
        <div className="all-gym-offer-banner-subtitle">
          Gym Offers Dashboard
        </div>
      </div>

      <h1 className="all-gym-offer-banner-title">
        All Gym Offers Management Portal
      </h1>

      <p className="all-gym-offer-banner-description">
        Manage all gym offers across all locations. View, edit, and monitor
        performance.
      </p>

      <div className="all-gym-offer-banner-controls">
        <div className="all-gym-offer-search-container">
          <div className="all-gym-offer-search-input-wrapper">
            <SearchIcon />
            <input
              type="text"
              placeholder="Search offers or gyms..."
              className="all-gym-offer-search-input"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>

        {/* <button className="all-gym-offer-filter-button">
          <FilterIcon />
          <span>Filter Offers</span>
        </button> */}
      </div>
    </div>
  );
};

export default AllGymOffersBanner;
